import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom"; // Import useLocation here
import Project_Details from "./pages/Project_Details";
import Home from "./pages/Home";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPassword from "./pages/ForgotPassword";
import Admin from "./pages/Admin";
import PrivateRoute from "./components/PrivateRoute";
import AllProjects from "./components/Admin-Projects/AllProjects";


function AppContent() {
  const location = useLocation(); 

  

  return (
    <>
      {!location.pathname.startsWith("/admin") && <NavBar /> }
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product-details/:id" element={<Project_Details />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin" element={<PrivateRoute />}>
          <Route path="/admin" element={<Admin />}>
            <Route path="all-product" element={<AllProjects />} />
          </Route>
        </Route>
      </Routes>
      {!location.pathname.startsWith("/admin") && <Footer /> }

    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
